import type { ComponentType } from 'react';
import Dashboard from '@/features/dashboard/pages/Dashboard';
import LicenseKeys from '@/features/licenses/pages/LicenseKeys';
import Devices from '@/features/devices/pages/Devices';
import AdminUsers from '@/features/users/pages/AdminUsers';
import Logs from '@/features/logs/pages/Logs';
import Skills from '@/features/skills/pages/Skills';
import { ROUTE_SEGMENTS } from '@/constants/routes';

export interface ProtectedRouteConfig {
  index?: boolean;
  path?: string;
  component: ComponentType;
}

/**
 * Child routes rendered inside the authenticated layout.
 */
export const PROTECTED_ROUTES: ProtectedRouteConfig[] = [
  { index: true, component: Dashboard },
  { path: ROUTE_SEGMENTS.licenses, component: LicenseKeys },
  { path: ROUTE_SEGMENTS.devices, component: Devices },
  { path: ROUTE_SEGMENTS.users, component: AdminUsers },
  { path: ROUTE_SEGMENTS.logs, component: Logs },
  { path: ROUTE_SEGMENTS.skills, component: Skills },
];

